<template>
	<div>
		<LayoutConfiguracao>
			<h1 class="text-H5 mb-4 mt-10">
				{{ i18n.t('configuracaoColetaPilha') }}
			</h1>
			<div class="flex flex-col gap-4">
				<div>
					<span class="flex gap-1 items-center">
						<label class="text-label">{{ i18n.t('tipoDeMedicao') }} *</label>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">{{ i18n.t('tipoDeMedicao') }}</p>
								<p class="text-s">{{ i18n.t('tipoDeMedicaoHelp') }}</p>
							</div>
						</Tooltip>
					</span>
					<Radio
						v-model="pilha.config_app_tx_pilha_tpmd"
						:label="`${i18n.t('diametro')} (${i18n.t('hbd')})`"
						name="tipo-medicao"
						model-value="diametro"
					/>
					<Radio
						v-model="pilha.config_app_tx_pilha_tpmd"
						:label="`${i18n.t('circunferencia')} (${i18n.t('hbc')})`"
						name="tipo-medicao"
						model-value="circunferencia"
					/>
				</div>
				<div>
					<label class="text-label">{{ i18n.t('numeroDiametrosObrigatorios') }} *</label>
					<Radio
						v-model="pilha.config_app_nr_numero_de_diametros_obrigatorio"
						label="1"
						name="numero-diametros"
						:model-value="1"
					/>
					<Radio
						v-model="pilha.config_app_nr_numero_de_diametros_obrigatorio"
						label="2"
						name="numero-diametros"
						:model-value="2"
					/>
				</div>
				<div>
					<span class="flex gap-1 items-center">
						<label class="text-label">{{ i18n.t('numeroCasasDecimais') }} *</label>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">{{ i18n.t('numeroCasasDecimais') }}</p>
								<p class="text-s">{{ i18n.t('numeroCasasDecimaisHelp') }}</p>
							</div>
						</Tooltip>
					</span>
					<Radio
						v-model="pilha.config_app_nr_numero_de_casas_decimais"
						label="1"
						name="casas-decimais"
						:model-value="1"
					/>
					<Radio
						v-model="pilha.config_app_nr_numero_de_casas_decimais"
						label="2"
						name="casas-decimais"
						:model-value="2"
					/>
				</div>
				<div class="flex flex-col gap-2">
					<span class="flex gap-1 items-center">
						<h2 class="text-default-bold">{{ i18n.t('validacaoDeAltura') }}</h2>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">{{ i18n.t('validacaoDeAltura') }}</p>
								<p class="text-s">{{ i18n.t('validacaoDeAlturaHelp') }}</p>
							</div>
						</Tooltip>
					</span>
					<div class="flex gap-4">
						<Input
							v-model.number="pilha.config_app_nr_altura_minima"
							:label="i18n.t('minimoCM')"
						/>
						<Input
							v-model.number="pilha.config_app_nr_altura_maxima"
							:label="i18n.t('maximoM')"
						/>
					</div>
				</div>
				<div class="flex flex-col gap-2">
					<span class="flex gap-1 items-center">
						<h2 class="text-default-bold">{{ i18n.t('validacaoLargura') }}</h2>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">{{ i18n.t('validacaoLargura') }}</p>
								<p class="text-s">{{ i18n.t('validacaoLarguraHelp') }}</p>
							</div>
						</Tooltip>
					</span>
					<div class="flex gap-4">
						<Input
							v-model.number="pilha.config_app_nr_largura_minima"
							:label="i18n.t('minimoM')"
						/>
						<Input
							v-model.number="pilha.config_app_nr_largura_maxima"
							:label="i18n.t('maximoM')"
						/>
					</div>
				</div>
				<div class="flex flex-col gap-2">
					<span class="flex gap-1 items-center">
						<h2 class="text-default-bold">{{ i18n.t('validacaoDiametro') }}</h2>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">{{ i18n.t('validacaoDiametro') }}</p>
								<p class="text-s">{{ i18n.t('validacaoDiametroHelp') }}</p>
							</div>
						</Tooltip>
					</span>
					<div class="flex gap-4">
						<Input
							v-model.number="pilha.config_app_diametro_minimo"
							:label="i18n.t('minimoCM')"
						/>
						<Input
							v-model.number="pilha.config_app_diametro_maximo"
							:label="i18n.t('maximoCM')"
						/>
					</div>
				</div>
				<div class="flex justify-end">
					<Button
						:text="i18n.t('save')"
						:loading="updating"
						@click="atualizarConfiguracoes"
					/>
				</div>
			</div>
		</LayoutConfiguracao>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import Button from '../../../components/ui/button/Button.vue'
import Input from '../../../components/ui/input/Input.vue'
import Radio from '../../../components/ui/radio/Radio.vue'
import Tooltip from '../../../components/ui/tooltip/Tooltip.vue'
import { useConfiguracoesAplicativo } from '../../../composables/useConfiguracoesAplicativo'
import LayoutConfiguracao from '../../../layouts/LayoutConfiguracao.vue'
import i18n from '../../../VueI18n'

const { pilha, updating, atualizarConfiguracoes } = useConfiguracoesAplicativo()
</script>

<style></style>
